import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetAudiencesBasic_audiences_edges_node as Audience,
    GetAudiencesBasic as GetAudiencesQuery,
    GetAudiencesBasicVariables as GetAudiencesQueryVariables,
} from 'nutshell-graphql-types';

import GET_AUDIENCES from '../queries/get-audiences.graphql';

export const useGetAudiences = (
    variables?: GetAudiencesQueryVariables
): {
    isLoading: boolean;
    errorMessage: string | null | undefined;
    audiences: Audience[];
    refetch: () => Promise<any>;
} => {
    const {loading, refetch, data, error} = useQuery<GetAudiencesQuery, GetAudiencesQueryVariables>(
        GET_AUDIENCES,
        {
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network',
            variables,
        }
    );

    return {
        isLoading: loading,
        refetch,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        audiences:
            data && data.audiences && data.audiences.edges
                ? data.audiences.edges.map((edge) => edge.node)
                : [],
    };
};
